import React, { useEffect, useRef } from "react";

const QuizzWidgetResults = ({ result, goBackToQuizz, backToQuizzText }) => {
    if (!result) return null;

    const resultsContainerRef = useRef(null);

    const { topSummary, results, hints, bottomSummary } = result;

    const product = results[0];

    useEffect(() => {
        const navHeight = window.matchMedia('(max-width: 1023px)').matches ? 64 : 80;
        window.scrollTo(0, resultsContainerRef.current.offsetTop - navHeight);
    }, []);

    return (
        <>
            <div ref={resultsContainerRef} className={`pt-64 ${product.hasImage ? "pb-120" : "pb-64"} bg-gray-brown`}>
                <div className="container">
                    <button className="link link--primary link--arrow-left outline-none focus:shadow-outline focus:rounded 2xs:mb-20" onClick={goBackToQuizz}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.02 8.82">
                            <path d="M4.15,8.53A1,1,0,0,0,5.56,7.11L3.85,5.41H17a1,1,0,0,0,0-2H3.85l1.71-1.7A1,1,0,0,0,5.56.3,1,1,0,0,0,4.85,0a1,1,0,0,0-.7.29L0,4.41,4.15,8.53Z"></path>
                        </svg>
                        <span>{backToQuizzText}</span>
                    </button>
                    {topSummary.hasImage && topSummary.imageUrl?.length > 0 && (
                        <img className="max-w-140 mx-auto mb-32" src={topSummary.imageUrl} />
                    )}
                    <h2 className="text-32 md:text-28 text-primary font-bold text-center">
                        {topSummary.text}
                    </h2>
                </div>
            </div>
            <div className="container container--sm">
                {product.hasImage ? (
                    <div className="flex xs:flex-col-reverse">
                        <div className="w-3/5 xs:w-full text-right xs:text-center my-40 xs:mt-24 flex items-center">
                            <div>
                                <h2 className="text-32 md:text-28 font-bold mb-12">{product.title}</h2>
                                <p>{product.description}</p>
                                {product.hasLink && (
                                    <a
                                        className="btn btn--primary btn--arrow-right mt-40"
                                        href={product.linkUrl}
                                    >
                                        <span>{product.linkText}</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 18.02 8.82"
                                        >
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="M13.86.29a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.41l1.71,1.7H1a1,1,0,0,0,0,2H14.16l-1.71,1.7a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.7-.29L18,4.41Z"
                                            ></path>
                                        </svg>
                                    </a>
                                )}
                            </div>
                        </div>
                        <div className="w-2/5 xs:w-full">
                            <img
                                className="-mt-72 sm:-mt-56 xs:-mt-72 mx-auto max-h-540 xs:max-h-400 max-w-4/5 mb-40 xs:mb-0"
                                src={product.imageUrl}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="my-64">
                        <div className="text-center">
                            <h2 className="text-32 md:text-28 font-bold mb-12">{product.title}</h2>
                            <p>{product.description}</p>
                            {product.hasLink && (
                                <a
                                    className="btn btn--primary btn--arrow-right mt-40"
                                    href={product.linkUrl}
                                >
                                    <span>{product.linkText}</span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 18.02 8.82"
                                    >
                                        <path
                                            xmlns="http://www.w3.org/2000/svg"
                                            d="M13.86.29a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.41l1.71,1.7H1a1,1,0,0,0,0,2H14.16l-1.71,1.7a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.7-.29L18,4.41Z"
                                        ></path>
                                    </svg>
                                </a>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <div className="bg-primary py-50">
                <div className="container container--sm flex justify-center">
                    <h3 className="text-white text-24 font-bold title-stars text-center">
                        {hints[0]}
                    </h3>
                </div>
            </div>
            <div className="bg-gray-brown py-50">
                <div className="container container--md">
                    <div className="flex xs:flex-col relative -m-20 flex-wrap">
                        {bottomSummary.items.map((item, index) => {
                            if (index >= 3) return null;
                            return (
                                <div key={index} className="w-1/3 sm:w-1/2 p-20 xs:w-full xs:flex xs:flex-col">
                                    {item.hasImage && 
                                        <img className="w-full aspect-[4/3] object-cover mb-16" src={item.imageUrl}/>
                                    }
                                    <h2 className="text-32 xs:text-24 font-bold text-red-base leading-xs mb-16">
                                        {item.headline}
                                    </h2>
                                    {item.hasDescription &&
                                        <div className="rich-text">
                                            <p>{item.description}</p>
                                        </div>
                                    }
                                    {item.hasLink && 
                                        <div className="mt-24">
                                            <a
                                                className="btn btn--primary btn--arrow-right"
                                                href={item.linkUrl}
                                            >
                                                <span>{item.linkText}</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.02 8.82">
                                                    <path
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        d="M13.86.29a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.41l1.71,1.7H1a1,1,0,0,0,0,2H14.16l-1.71,1.7a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.7-.29L18,4.41Z"
                                                    ></path>
                                                </svg>
                                            </a>
                                        </div>
                                    }
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuizzWidgetResults;
